const QueryKeys = {
  socialMediaLinks: 'social-media-links',
  socialUserInfo: 'social-user-info',
  socialBusinessUserInfo: 'social-business-user-info',
  enterpriseLinksManagement: 'enterprise-links-management',
  enterpriseLinksReview: 'enterprise-links-review',
  enterprise: 'enterprise-organizations',
  enterpriseUsers: 'enterprise-users',
  enterpriseMonitoring: 'enterprise-monitoring',
  enterpriseSentimentAnalysis: 'enterprise-sentiment-analysis',
  enterpriseNewsWire: 'enterprise-news-wire',
};

export default QueryKeys;
